import React from 'react';

import styled from 'styled-components';
import stores from '../../stores';

const StudentInfoContainer = styled.div`
  margin: 16px 0 32px;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: -0.1px;
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 800;
  line-height: 1.38;
  letter-spacing: 0.2px;
  color: #354354;
  margin-bottom: 2px; 
`;

const StudentInfo = () => {
  const { prenom: Name, nom: Surname, phone } = stores.userStore.userInfo;

  return (
    <StudentInfoContainer>
      <Title>Mes coordonnées</Title>
      <div>{`${Name} ${Surname}`}</div>
      <div>{phone}</div>
    </StudentInfoContainer>
  );
};

export { StudentInfo };
